import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { calculateFiltersDates } from '../../../utils/filters'
import { Driver } from '../../../types/driver'

export type { Driver }

export interface TimeSheetItem {
	driverName: string
	driverId: number
	status: string
	timesheetDate: string
	timeSheetId: number
	totalServices: number
	comments: string
}
export interface DataInfo {
	pageNumber?: number
	pageSize?: number
	totalPages?: number
	totalResults?: number
	itemList: TimeSheetItem[]
}

export enum TimesheetStatusEnum {
	Submitted = 'Submitted',
	NotSubmitted = 'NotSubmitted',
	SubmittedWithoutChanges = 'SubmittedWithoutChanges',
	AutoSubmitted = 'AutoSubmitted',
	Approved = 'Approved',
	Rejected = 'Rejected',
	Edited = 'Edited',
}

export type TimesheetStatus =
	| 'Submitted'
	| 'NotSubmitted'
	| 'SubmittedWithoutChanges'
	| 'AutoSubmitted'
	| 'Approved'
	| 'Rejected'
	| 'Edited'
	| 'ReadyForEdit'

export interface Filters {
	currentPage: number
	pageSize: number
	orderByColumn: 'TimeSheetDate' | 'DriverName' | 'DriverId' | 'InternalNumber'
	ascending: boolean
	startDate?: string
	endDate?: string
	driverId?: number
	status?: TimesheetStatus[]
	branchId?: number
	submitted?: boolean
}

export interface TimesheetsTotals {
	autoSubmitted: number
	edited: number
	readyForEdit: number
	notSubmitted: number
	rejected: number
	submitted: number
	submittedWithoutChanges: number
	approved: number
	totalFiltered: number
}
export interface FolhadePontoDetailsState {
	driverTableId: number
	filters: Filters
	loading: boolean
	data: DataInfo
	error: string | undefined
}

const initialState: FolhadePontoDetailsState = {
	driverTableId: 0,
	filters: {
		startDate: String(calculateFiltersDates('StartDate')),
		endDate: String(calculateFiltersDates('EndDate')),
		driverId: undefined,
		branchId: undefined,
		currentPage: 1,
		pageSize: 20,
		ascending: false,
		orderByColumn: 'TimeSheetDate',
		status: ['NotSubmitted', 'Submitted', 'AutoSubmitted', 'Rejected' /* 'SubmittedWithoutChanges' */],
	},
	data: {
		itemList: [
			{
				driverName: '',
				driverId: 0,
				timesheetDate: '',
				totalServices: 0,
				timeSheetId: 0,
				status: '',
				comments: '',
			},
		],
		pageNumber: 0,
		pageSize: 0,
		totalPages: 0,
		totalResults: 0,
	},
	loading: true,
	error: '',
}

export const timesheetDetailsSlice = createSlice({
	name: 'timesheetDetails',
	initialState,
	reducers: {
		addFilters: (state, action: PayloadAction<Partial<Filters>>) => {
			Object.assign(state.filters, action.payload)
		},
	},
})

export const { addFilters } = timesheetDetailsSlice.actions
